import type { UseQueryOptions } from "@tanstack/react-query";
import type { PagedResult, ProspectSearchResult } from "@/models";
import type { Axios } from "axios";

export const searchProspects = async (
  axiosInstance: Axios,
  query: string,
  page: number
): Promise<PagedResult<ProspectSearchResult>> => {
  const response = await axiosInstance.get<PagedResult<ProspectSearchResult>>(
    "/prospects/search",
    {
      params: { search: query, page }
    }
  );
  return response.data;
};

export const searchProspectsQuery = (
  axiosInstance: Axios,
  query: string,
  page: number,
  options: Partial<UseQueryOptions<PagedResult<ProspectSearchResult>>> = {}
): UseQueryOptions<PagedResult<ProspectSearchResult>> => ({
  queryKey: ["prospectSearch", query, page],
  queryFn: () => searchProspects(axiosInstance, query, page),
  ...options
});
